import "./TextArea.css";

import { useEffect, useState } from "react";

const TextArea = ({
  placeholder = "",
  onChange = () => {},
  value = "",
  name = "",
}) => {
  const [textAreaValue, setTextAreaValue] = useState(value);

  // Update internal state when value prop changes
  useEffect(() => {
    setTextAreaValue(value);
  }, [value]);

  const handleChange = event => {
    setTextAreaValue(event.target.value);
    onChange(event);
  };

  return (
    <textarea
      className="App-textarea"
      placeholder={placeholder}
      value={textAreaValue}
      name={name}
      onChange={handleChange}
    ></textarea>
  );
};

export default TextArea;
